export default __webpack_public_path__ + "static/media/Hospital Planning.40bbbfb1.png";